module.exports = __webpack_public_path__ + "static/img/manual-32.bb610d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-32.png
// module id = G1SO
// module chunks = 4